module.exports = __webpack_public_path__ + "static/img/kanban06.670ccc94.png";